/**
 * Simple wrapper used to get Form context and pass to wrapped component without validation
 */

import React, { Component } from "react";
import { FormContext } from "./FormContext";

export function withForm(Component) {
  return class WithForm extends Component {
    render() {
      return (
        <FormContext.Consumer>
          {context => <Component {...this.props} context={context} />}
        </FormContext.Consumer>
      );
    }
  };
}
